import React from "react";

import { MessageBoxWidgetDto } from "@intelligems/ig-types";
import { styled } from "@mui/material";
import { DeviceWidget } from "@src/domains/WidgetLibrary/DeviceWidget";
import { UserInterfaceWidgetPreview as Preview } from "@src/features/personalizations/components/offerModifications/widgets/UserInterfaceWidgetPreview";
import { WidgetMoreMenu } from "@src/features/personalizations/components/offerModifications/widgets/WidgetMoreMenu";

import { IgMessageBox } from "./IgMessageBox";
import { MessageBoxWidgetPreview } from "./MessageBoxWidgetPreview";

interface MessageBoxPreviewProps {
  widget: MessageBoxWidgetDto;
  isEdit?: boolean;
  hideLabel?: boolean;
}
export const MessageBoxPreview = ({
  widget,
  isEdit,
  hideLabel,
}: MessageBoxPreviewProps) => {
  if (isEdit)
    return (
      <Preview renderLocation={"settings"}>
        {!hideLabel && <Preview.Label label={"Preview"} />}
        <Preview.Widget device={"desktop"} renderLocation={"settings"}>
          <IgMessageBox device={"desktop"} widget={widget} />
        </Preview.Widget>
      </Preview>
    );

  return (
    <MessageBoxWidgetPreview widget={widget}>
      <DeviceWidget device={"desktop"}>
        <IgMessageBox device={"desktop"} widget={widget} />
      </DeviceWidget>
    </MessageBoxWidgetPreview>
  );
};
